import api from 'api'

export type IndeedFlexOtpChallengeResponse = {
  challengeToken: string
  challengeTokenExpiresAt: string
}

export const requestIndeedFlexOtpChallenge =
  async (): Promise<IndeedFlexOtpChallengeResponse> => {
    const result = await api.post<IndeedFlexOtpChallengeResponse>(
      '/admin/indeed_flex/otp/challenge'
    )
    return result.data
  }
